/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import {Observable} from 'rxjs';

const ajax = Observable.ajax;

const HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};

export function get(url, headers) {
    headers = Object.assign({}, HEADERS, headers);
    return new Promise((resolve, reject) => {
        ajax.get(url, headers).subscribe(response => {
            return resolve(response.response);
        }, err => {
            return reject({
                status: err.xhr.status,
                response: err.xhr.response
            });
        });
    });
}

export function post(url, body, headers) {
    headers = Object.assign({}, HEADERS, headers);
    return new Promise((resolve, reject) => {
        ajax.post(url, body, headers).subscribe(response => {
            return resolve(response.response);
        }, err => {
            return reject({
                status: err.xhr.status,
                response: err.xhr.response
            });
        });
    });
}

export function put(url, body, headers) {
    headers = Object.assign({}, HEADERS, headers);
    return new Promise((resolve, reject) => {
        ajax.put(url, body, headers).subscribe(response => {
            return resolve(response.response);
        }, err => {
            return reject({
                status: err.xhr.status,
                response: err.xhr.response
            });
        });
    });
}

export function patch(url, body, headers) {
    headers = Object.assign({}, HEADERS, headers);
    return new Promise((resolve, reject) => {
        ajax.patch(url, body, headers).subscribe(response => {
            return resolve(response.response);
        }, err => {
            return reject({
                status: err.xhr.status,
                response: err.xhr.response
            });
        });
    });
}

export function remove(url, headers) {
    headers = Object.assign({}, HEADERS, headers);
    return new Promise((resolve, reject) => {
        ajax.delete(url, headers).subscribe(response => {
            return resolve(response.response);
        }, err => {
            return reject({
                status: err.xhr.status,
                response: err.xhr.response
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/_thunks/request.helper.js